export type Scalars = {
  DateTime: string; // Date on BE, string on FE
};

export enum FollowupCadenceUnits {
  None = 'none',
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Weeks = 'weeks',
}

export type InternalDataReferenceTypes = 'pay-organizer-main-debtor' | 'pay-organizer-debtor-2' | 'pay-organizer-non-filing';

export type DocumentRequest = {
  id: string;
  creatorId: string;
  title: string;
  isFollowupEnabled: boolean;
  isArchived: boolean;
  autoAssignCreatorInWorkflows: boolean;
  autoAssignCustomerInWorkflows: boolean;
  followupCadence: number;
  followupCadenceUnits: FollowupCadenceUnits;
  isForCreator: boolean;
  internalDataReferenceType: InternalDataReferenceTypes | null;
  slug: string;
  type:
    | 'basic'
    | 'income-data';
};

export type DocumentRequestFileIntegrations = 'pacer';
export type DocumentRequestFileIntegrationFileNames = 'debtor.txt' | 'petition.pdf' | 'creditor.txt' | 'credit.pdf';

export type DocumentRequestFile = {
  id: string;
  documentRequestId: string;
  fileName: string;
  fileDescription: string | null;
  isRequired: boolean;
  isForYourEyesOnly: boolean;
  order: number;
  internalDataType: 'income-data' | 'asset-data' | 'personal-data' | 'prompt-data' | null;
  internalDataPromptHelp: string | null;
  integrationSlug: DocumentRequestFileIntegrations | null;
  integrationFileName: DocumentRequestFileIntegrationFileNames | null;
};

export enum DocumentRequestStatus {
  SUCCEEDED = 'succeeded',
  IN_PROGRESS = 'in-progress',
  IN_REVIEW = 'in-review',
  FAILED = 'failed',
  SKIPPED='skipped',
}

export enum DocumentRequestFileStatus {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  ACTION_REQUIRED = 'action-required',
}

export type DocumentRequestUser = {
  id: string;
  documentRequestId: string;
  personId: string;
  submitForReviewModalCloseForClient: boolean | null;
  submitForReviewModalCloseForAttorney: boolean | null;
  creatorId: string;
  status: DocumentRequestStatus;
  actionRequiredFiles: number;
  hasPermission: boolean;
  isCollaborator: boolean;
  uploadedRequiredFiles: number;
  totalRequiredFiles: number;
  uploadedFiles: number;
  totalFiles: number;
  userWorkflowId: string | null;
  createdAt: Scalars['DateTime'];
  type:
    | 'basic'
    | 'income-data';
};

export type DocumentRequestUserPermissions = {
  id: string;
  documentRequestId: string;
  personId: string;
};

export type ApprovedBy = { id: string; name: string | null };
export type OldApprovedBy = string | null; // We'll migrate off this soon
export type ValidationStatus = { status: string, approvedBy: OldApprovedBy | ApprovedBy } | null;
export enum CurrencyUnknown {
  Unknown = 'Unknown'
}

export type CurrencyType = 'USD' | 'CAD' | 'EUR' | 'GBP';

export type CurrencyValue = {
  currency: CurrencyType;
  amount: number | null | CurrencyUnknown;
  text: string | null;
  isUnknown?: boolean;
};

export type MonthlyDollarValue = {
  month: string,
  income: CurrencyValue;
  expenses: CurrencyValue | null;
  useInMeansTest: boolean;
  useInCalculation: boolean;
};
export type IncomeSource = 'Employment'
  | 'Social Security'
  | 'Rental Property income'
  | 'Interest & Dividends'
  | 'Disability'
  | 'Unemployment'
  | 'Retirement/Pension'
  | 'Government assistance (welfare, food stamps, etc.)'
  | 'Child support or alimony received'
  | 'Business, profession, or farm'
  | 'Other';

export type IncomeMetadata = {
  incomeSource: IncomeSource;
  payFrequency: 'Weekly' | 'Biweekly' | 'Semi-monthly' | 'Monthly' | 'Quarterly' | 'Annually';
  startDate: string | null;
  endDate: string | null;
  monthlyDollarValue: MonthlyDollarValue[];
};

export type DocumentRequestUserFile = {
  id: string;
  documentRequestUserId: string;
  documentRequestFileId: string | null;
  documentId: string | null;
  personId: string;
  fileName: string | null;
  fileDescription: string | null;
  isRequired: boolean;
  isForYourEyesOnly: boolean | null;
  status: DocumentRequestFileStatus;
  rejectionMessage: string | null;
  rejectedAt: Scalars['DateTime'] | null;
  creatorId: string;
  hasPermission: boolean;
  order: number;
  validationStatus: ValidationStatus | null;
  internalDataType: 'income-data' | 'asset-data' | 'personal-data' | 'prompt-data' | null;
  internalDataPromptHelp: string | null;
  metadata: IncomeMetadata | null;
};

export type DocumentAnalysisRaw = Record<string, unknown> | null;
export type DocumentAnalysis = {
  documentAnalysis: {
    errorMessage?: string;
    isBlurry: boolean | null;
    isExpired: boolean | null;
    matchesDocumentDescription: boolean | null;
    matchesDocumentDescriptionFailReason: string | null;
  } | null;
  summary: string | null;
} | null;
export type DocumentRequestUserFileDocument = {
  documentRequestUserFileId: string;
  documentId: string;
  documentAnalysis: DocumentAnalysis;
  documentAnalysisRaw: DocumentAnalysisRaw;
  validationStatus: ValidationStatus | null;
};

export enum DocumentStatus {
  UPLOADED = 'uploaded',
  IN_PROGRESS = 'in-progress',
  FAILED = 'failed',
}

export type Document = {
  createdAt: Scalars['DateTime'];
  creatorId: string | null;
  fileName: string;
  fileSize: number;
  hasContentPermission: boolean;
  id: string;
  isCollaborator: boolean;
  mimeType: string;
  personId: string;
  status: DocumentStatus;
  uploadedAt: Scalars['DateTime'];
  uploadedBy: {
    name: string | null;
  };
  rank: number;
  referenceId: string | null;
  referenceType:
    | 'invoice'
    | 'payment'
    | 'custom-terms'
    | 'compiled-document-request-user'
    | 'credit-report-response'
    | 'credit-report-property-search'
    | 'credit-report-previous-bankruptcies'
    | 'credit-report-foreclusers'
    | 'user-workflow-document'
    | null;
  rejectedAt?: Scalars['DateTime'] | null;
  rejectionMessage?: string | null;
};

export type ArchiveFile = {
  path: string;
  documentId: string;
};

export type Archive = {
  id: string;
  name: string;
  documentId: string | null;
  creatorId: string;
  files: ArchiveFile[];
};

export type PaystubAnalysis = {
  amountPerPayPeriod: number | null;
  businessExpenses: number | null;
  domesticSupportObligations: number | null;
  insurance: number | null;
  mandatoryContributionsForRetirementPlans: number | null;
  netPay: number | null;
  otherDeductions: number | null;
  overtimePerPayPeriod: number | null;
  payDate: string | null;
  requiredRepaymentsOfRetirementFundLoans: number | null;
  taxMedicareAndSocialSecurityDeductions: number | null;
  unionDues: number | null;
  voluntaryContributionsForRetirementPlans: number | null;
  grossPay: number | null;
};

export type PromptData = {
  included: Array<{
    documentId: string;
    fileName: string;
  }>;
  excluded: Array<{
    documentId: string;
    fileName: string;
  }>;
};

export type InternalData = {
  id :string;
  slug: string;
  userWorkflowId: string;
  data: unknown;
};

export type InternalDataSource = {
  id: string;
  internalDataId: string;
  referenceId: string;
  referenceType: string;
  internalData:InternalData;
};

export type MeansTestAiResponse = {
  calculationExplanation: string;
  calculationExplanationHtml: string;
  grossMonthlyIncome:number
  alimonyAndMaintenancePayments: number;
  otherHouseholdIncome: number;
  interestDividendsAndRoyalties: number;
  unemploymentCompensation: number;
  pensionOrRetirementIncome: number;
  rentalPropertyIncome: number;
};

export type MeansTestResponse = {
  id: string;
  documentRequestUserId: string;
  userWorkflowId: string;
  aiRequestId: string | null;
  data: MeansTestAiResponse;
  status?: 'pending' | 'completed' | 'failed';
  aiFailedReason?: string | null;
};
